import { render, staticRenderFns } from "./IngredientesListagem.vue?vue&type=template&id=4fb0b269"
import script from "./IngredientesListagem.vue?vue&type=script&lang=js"
export * from "./IngredientesListagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports